export function formatPrice(amountCents, currency = "brl") {
  const value = (amountCents || 0) / 100;
  return value.toLocaleString("pt-BR", { style: "currency", currency: (currency || "brl").toUpperCase() });
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return "—";
  }
}

export const LEVEL_META = {
  pawn: { piece: "♟", name: "Peão", label: "Iniciante" },
  knight: { piece: "♞", name: "Cavalo", label: "Básico" },
  bishop: { piece: "♝", name: "Bispo", label: "Intermediário" },
  rook: { piece: "♜", name: "Torre", label: "Avançado" },
  queen: { piece: "♛", name: "Dama", label: "Expert" },
  king: { piece: "♚", name: "Rei", label: "Master" },
};
